import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCarrierService,
  AdminCarrierListModel,
  CarrierStatus,
  PageModelCarrierModel,
  CarrierModel,
  CarrierOwnerType,
  CarrierBusinessRequest,
  BaseDocumentRequest,
  Ss4DocumentRequest,
  PageModelAuditModel,
  AnyValueModelCurrency,
  AnyValueModelLanguage,
  AnyValueModelUnitSystemType
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCarrierApiService {
  constructor(private apiService: AdministrationCarrierService) {}

  public changeCarrierStatus(carrierId: string, status: CarrierStatus, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminCarrierListModel> {
    return this.apiService.adminCarrierChangeStatus(carrierId, status, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCarrier(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelCarrierModel> {
    return this.apiService.adminCarrierDelete(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteInsurance(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierDeleteInsurance(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteSs4(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierDeleteSs4(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierAddress(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditAddress(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editOwnerType(carrierId: string, ownerType: CarrierOwnerType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditBilling(carrierId, ownerType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editBusiness(carrierId: string, body: CarrierBusinessRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditBusiness(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierName(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditCompanyName(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editInsurance(carrierId: string, body: BaseDocumentRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditInsurance(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editSs4(carrierId: string, body: Ss4DocumentRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditSs4(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierVerified(carrierId: string, verified: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierEditVerified(carrierId, verified, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrier(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.adminCarrierGet(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierAudit(carrierId: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAuditModel> {
    return this.apiService.adminCarrierGetAudit(carrierId, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierListModel(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminCarrierListModel> {
    return this.apiService.adminCarrierGetListModel(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCurrency(carrierId: string, anyValueModelCurrency: AnyValueModelCurrency, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierSetCurrency(carrierId, anyValueModelCurrency, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setLanguage(carrierId: string, anyValueModelLanguage: AnyValueModelLanguage, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierSetLanguage(carrierId, anyValueModelLanguage, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setUnit(carrierId: string, anyValueModelUnitSystemType: AnyValueModelUnitSystemType, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierSetUnit(carrierId, anyValueModelUnitSystemType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public switchCountry(carrierId: string, enabled: boolean, value: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierSwitchCountry(carrierId, enabled, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
